<app-activity
  *ngIf="id"
  [model]="'entities/clients'"
  [modelId]="id"
></app-activity>
